import styled from '@emotion/styled'

export const TableBody = styled.tbody()
